import cx from 'clsx';
import { Tooltip } from '@mui/material';

import { getBackgroundComplianceColor } from '../helpers/compliance';
import { ComplianceStatus } from '../types';
import { getComplianceStatusText } from '../views/practice/dentalenhancements/utils';

const CompliancePlip = ({
  status,
  className,
  large,
  medium,
  message
}: {
  status: ComplianceStatus;
  className?: string;
  large?: boolean;
  medium?: boolean;
  message?: string;
}) => {
  return (
    <Tooltip
      title={message ?? getComplianceStatusText(status)}
      placement="bottom"
      disableInteractive
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: { offset: [0, -8] }
            }
          ]
        }
      }}
    >
      <span
        className={cx(
          `compliance-circle`,
          getBackgroundComplianceColor(status),
          { ['compliance-circle__large']: large, ['compliance-circle__medium']: medium },
          className
        )}
      />
    </Tooltip>
  );
};

export default CompliancePlip;
